import { useState, useEffect, useCallback } from 'react';
import { EditOutlined, FormOutlined } from '@ant-design/icons';
import { AModal, ASwitch, AInput } from '../../../components';
import { Form } from 'antd';
import { useToast } from '../../../hooks/toast';
import {
  schemaTerminologyCreate,
  schemaTerminologyEdit,
} from '../schemas/yup.terminology.schema';
import { ITerminology } from '../../../shared/interfaces';
import { patchTerminology, postTerminology } from '../../../http';

interface ITerminologyProps {
  open: boolean;
  close: () => void;
  terminology: ITerminology | null;
  setTerminologies: React.Dispatch<React.SetStateAction<ITerminology[]>>;
}

const TerminologyCreateEdit: React.FC<ITerminologyProps> = ({
  open,
  close,
  terminology,
  setTerminologies,
}) => {
  const { addToast } = useToast();
  const [description, setDescription] = useState<string>('');
  const [status, setStatus] = useState<boolean>(false);

  const handleCreate = useCallback(async () => {
    schemaTerminologyCreate
      .validate({
        description,
      })
      .then(async (validated) => {
        await postTerminology(validated)
          .then((data) => {
            setTerminologies((state: ITerminology[]) => [...state, data]);
            addToast({
              type: 'success',
              title: 'Cadastrado',
              description: 'Cadastrado com sucesso.',
            });
            close();
          })
          .catch((error) => {
            addToast({
              type: 'error',
              title: 'Erro',
              description: error.response.data.error ?? 'Erro ao cadastrar.',
            });
          });
      })
      .catch((err) => {
        addToast({
          type: 'error',
          title: 'Campos em branco',
          description: err.errors[0],
        });
      });
  }, [description, status]);

  const handleEdit = useCallback(async () => {
    schemaTerminologyEdit
      .validate({
        description,
        status,
      })
      .then(async (validated) => {
        await patchTerminology(terminology?.id, validated)
          .then((data) => {
            setTerminologies((state) =>
              state.map((e) => (e.id !== data.id ? e : data)),
            );
            addToast({
              type: 'info',
              title: 'Alterado',
              description: 'Dados alterados com sucesso.',
            });
            close();
          })
          .catch((error) => {
            addToast({
              type: 'error',
              title: 'Erro',
              description: error.response.data.error ?? 'Erro ao alterar.',
            });
          });
      })
      .catch((err) => {
        addToast({
          type: 'error',
          title: 'Campos em branco',
          description: err.errors[0],
        });
      });
  }, [description, status]);

  useEffect(() => {
    if (terminology) {
      setDescription(terminology.description);
      setStatus(!!terminology.status);
    }
  }, [open]);

  return (
    <AModal
      open={open}
      close={close}
      title={
        terminology ? (
          <>
            <EditOutlined /> Editar
          </>
        ) : (
          <>
            <FormOutlined /> Cadastrar
          </>
        )
      }
      onOk={terminology ? handleEdit : handleCreate}
    >
      <Form layout="vertical" style={{ maxWidth: 600 }}>
        <Form.Item label="Descrição">
          <AInput
            placeholder="Informe a descrição"
            name="description"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
          />
        </Form.Item>
        {terminology && (
          <Form.Item label="Ativo">
            <ASwitch
              checked={status}
              checkedChildren="Sim"
              unCheckedChildren="Não"
              onChange={() => {
                setStatus(!status);
              }}
            />
          </Form.Item>
        )}
      </Form>
    </AModal>
  );
};

export default TerminologyCreateEdit;
